import {Col, Container, Row} from "react-bootstrap";
import React, {Component} from "react";
import './Home.css';

import MailUtil from "../../components/side-utils/mail-util/MailUtil";
import SocialUtil from "../../components/side-utils/social-util/SocialUtil";
import Header from "../../components/header/Header";
import Intro from "../sections/intro/Intro";
import Skills from "../sections/skills/Skills";
import About from "../sections/about/About";
import Projects from "../sections/projects/Projects";
import Contact from "../sections/contact/Contact";
import Footer from "../../components/footer/Footer";

class Home extends Component {
    render() {
        return (
            <div>
                <Header/>
                <Container fluid style={{marginTop:'76px'}}>
                    <Row>
                        <Col md={1} className={'d-none d-sm-none d-md-block'}>
                            <SocialUtil/>
                        </Col>
                        <Col md={10} sm={12} xs={12}>
                            <Intro/>
                            <About/>
                            <Skills/>
                            <Projects/>
                            <Contact/>
                            <Footer/>
                        </Col>
                        <Col md={1} className={'d-none d-sm-none d-md-block'}>
                            <MailUtil/>
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }
}

export default Home;